<template>
  <div class="custom-height-100p" style="overflow: auto">
    <div class="order-box" v-if="data && data.length > 0">
      <div
        v-for="(order, orderIndex) in data"
        :key="order.id"
        class="order-content-box"
      >
        <div class="custom-padding-10 custom-height-100p order-content">
          <div class="order-name-box order-name-active">
            <div class="order-name">
              <div>逝者：{{ order.death_name }}/{{ order.death_sex }}</div>
              <div>丧属：{{ order.master_name }}({{ order.master_phone }})</div>
              <div>负责人：{{ order.order_user_name }}({{ order.order_user_phone }})</div>
              <div>接单时间：{{ order.created_at }}</div>
            </div>
            <a-button class="info-btn" @click="showOrder(order.id)">详情</a-button>
          </div>

          <div
            v-if="order.nodes && order.nodes.length > 0"
            style="overflow: auto;"
            class="custom-height-100p custom-margin-top-10"
            :ref="`${'nodeActive'+orderIndex}`"
          >
            <div
              v-for="(node, index) in order.nodes"
              :key="index"
              class="node"
              :style="{backgroundColor: node.is_active ? '#ffd794ff' : '', color: node.is_active ? '#323232FF' : ''}"
            >
              <div class="node-name">{{ node.node_name }}</div>
              <div class="node-remark">{{ node.time }}</div>
            </div>
          </div>
          <no-data class="custom-card-box custom-margin-top-10" tip="暂无数据" v-else />
        </div>
      </div>
    </div>
    <no-data class="custom-card-box" v-else />
    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 详情模态框 -->
    <show-order
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
    />
  </div>
</template>

<script>
import { findProgressingServiceOrders } from '@/api/service_order'
import NoData from '@/views/home/NoData'
import Pagination from '@/components/Pagination'

export default {
  name: 'BigScreenOrder',
  components: {
    NoData,
    Pagination,
    ShowOrder: () => import('@/views/home/big_screen/show_order/index')
  },
  data() {
    return {
      data: [],
      query: {
        per_page: 8
      },
      pagination: {
        total_count: 0
      },
      showingId: 0,
      isShowInfoModal: false
    }
  },
  created() {
    this.fetchData()
    this.loopFetchData()
  },
  destroyed() {
    clearInterval(this.loopFetchDataTimer)
  },
  methods: {
    loopFetchData() {
      this.loopFetchDataTimer = setInterval(this.fetchData, 60000)
    },

    fetchData() {
      this.data = []
      findProgressingServiceOrders(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination

          this.$nextTick(() => {
            this.data.forEach((item, index) => {
              if (item.nodes) {
                item.nodes.forEach((node, nodeIndex) => {
                  if (node.is_active) {
                    this.$refs[`nodeActive${index}`][0].scrollTo(0, nodeIndex * 110)
                  }
                })
              }
            })
          })
        }
      })
    },

    showOrder(id) {
      this.showingId = id
      this.isShowInfoModal = true
    }
  }
}
</script>

<style lang="less" scoped>
.order-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 90%;

  .order-content-box {
    flex-basis: 25%;
    height: 50%;

    .order-content {
      display: flex;
      flex-direction: column;
    }

    .order-name-box {
      padding: 10px;
      border-radius: 6px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .order-name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        height: 120px;
      }

      .info-btn {
        border: none;
        background-color: #ffd794ff;
      }
    }

    .order-name-active {
      background: rgba(206, 123, 58, 100%);
      border: 2px solid rgba(206, 123, 58, 100%);
    }

    .node {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
      padding: 10px;
      min-height: 90px;
      font-size: 20px;
      border-radius: 10px;
      background-color: #37543e;
      flex-direction: column;

      .node-name {
        font-size: 24px;
      }

      .node-remark {
        white-space: pre-wrap;
      }

    }
  }
}
</style>

